import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Exercicio {
  id: string;
  icon: string;
  emoji: string;
  title: string;
  subtitle: string;
  precoMin: number;
  precoMax: number;
  color: string;
  description: string;
  benefits: string[];
  duration: string;
  level: string;
  meditacaoLink: string;
  meditacaoTitulo: string;
}

const exercicios: Exercicio[] = [
  {
    id: 'amor-ideal',
    icon: 'ri-heart-3-fill',
    emoji: '💖',
    title: 'Visualização do Amor Ideal',
    subtitle: 'Atraia relacionamentos saudáveis',
    precoMin: 47,
    precoMax: 97,
    color: '#E11D48',
    description: 'Para quem deseja atrair ou fortalecer relacionamentos saudáveis.',
    benefits: [
      'Exercício guiado de visualização do parceiro ideal',
      'Técnicas de alinhamento emocional',
      'Carta para o amor do futuro',
      'Áudio de meditação romântica',
      'Perguntas de autoconhecimento afetivo',
      'Ritual de manifestação de relacionamentos'
    ],
    duration: '45 minutos',
    level: 'Todos os níveis',
    meditacaoLink: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+amor+ideal+relacionamento+saud%C3%A1vel',
    meditacaoTitulo: 'Meditação para Relacionamentos Saudáveis'
  },
  {
    id: 'prosperidade-carreira',
    icon: 'ri-money-dollar-circle-fill',
    emoji: '💰',
    title: 'Prosperidade e Carreira',
    subtitle: 'Clareza sobre sucesso profissional e financeiro',
    precoMin: 47,
    precoMax: 97,
    color: '#0D9488',
    description: 'Clareza sobre sucesso profissional e financeiro.',
    benefits: [
      'Visualização da carreira dos sonhos',
      'Exercício de abundância financeira',
      'Planejamento de metas profissionais',
      'Carta para o eu próspero',
      'Técnicas de mentalidade de crescimento',
      'Ritual de prosperidade'
    ],
    duration: '50 minutos',
    level: 'Intermediário',
    meditacaoLink: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+prosperidade+abund%C3%A2ncia+carreira+sucesso',
    meditacaoTitulo: 'Meditação para Prosperidade e Abundância'
  },
  {
    id: 'saude-bem-estar',
    icon: 'ri-heart-pulse-fill',
    emoji: '🧘',
    title: 'Saúde e Bem-Estar Futuro',
    subtitle: 'Visualização da versão saudável e equilibrada',
    precoMin: 47,
    precoMax: 97,
    color: '#16A34A',
    description: 'Visualização da versão saudável e equilibrada.',
    benefits: [
      'Visualização do corpo ideal',
      'Exercício de energia e vitalidade',
      'Planejamento de hábitos saudáveis',
      'Carta para o eu saudável',
      'Meditação de cura e equilíbrio',
      'Ritual de bem-estar'
    ],
    duration: '40 minutos',
    level: 'Todos os níveis',
    meditacaoLink: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+sa%C3%BAde+bem+estar+corpo+saud%C3%A1vel+vitalidade',
    meditacaoTitulo: 'Meditação para Saúde e Vitalidade'
  },
  {
    id: 'proposito-vida',
    icon: 'ri-compass-3-fill',
    emoji: '🌟',
    title: 'Propósito de Vida',
    subtitle: 'Para quem sente que nasceu para algo maior',
    precoMin: 47,
    precoMax: 147,
    color: '#D97706',
    description: 'Para quem sente que nasceu para algo maior.',
    benefits: [
      'Exercício profundo de descoberta de propósito',
      'Mapeamento de talentos e paixões',
      'Visualização do legado futuro',
      'Carta para o eu realizado',
      'Áudio de conexão com propósito',
      'Plano de ação para viver com significado',
      'Ritual de compromisso com a missão'
    ],
    duration: '60 minutos',
    level: 'Avançado',
    meditacaoLink: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+prop%C3%B3sito+de+vida+miss%C3%A3o+alma',
    meditacaoTitulo: 'Meditação para Encontrar seu Propósito'
  },
  {
    id: 'identidade-alta-performance',
    icon: 'ri-trophy-fill',
    emoji: '👑',
    title: 'Identidade de Alta Performance',
    subtitle: 'Construção da mentalidade da sua melhor versão',
    precoMin: 97,
    precoMax: 197,
    color: '#7C3AED',
    description: 'Construção da mentalidade da sua melhor versão.',
    benefits: [
      'Exercício de construção de identidade',
      'Técnicas de alta performance',
      'Visualização do eu extraordinário',
      'Carta para o eu de excelência',
      'Áudio de reprogramação mental',
      'Planejamento de rotinas de elite',
      'Ritual de compromisso com a excelência',
      'Ferramentas de disciplina e foco'
    ],
    duration: '75 minutos',
    level: 'Avançado',
    meditacaoLink: 'https://www.youtube.com/results?search_query=medita%C3%A7%C3%A3o+guiada+alta+performance+mentalidade+vencedora+foco',
    meditacaoTitulo: 'Meditação para Alta Performance'
  }
];

export default function ExerciciosAvulsos() {
  const [selectedExercise, setSelectedExercise] = useState<string | null>(null);
  const selectedData = exercicios.find(ex => ex.id === selectedExercise);

  return (
    <>
      <section className="py-24 bg-luxury-black relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
        <div className="absolute top-40 right-20 w-72 h-72 bg-gold-500/3 rounded-full blur-[120px]"></div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-4 mb-6">
              <div className="w-12 h-px bg-gold-500/40"></div>
              <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">
                🌸 Exercícios Avulsos (Upsell)
              </span>
              <div className="w-12 h-px bg-gold-500/40"></div>
            </div>
            <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-white mb-4">
              Aprofunde Áreas <span className="text-gold-400 italic">Específicas</span>
            </h2>
            <p className="font-['Montserrat'] text-base text-white/50 max-w-3xl mx-auto font-light tracking-wide">
              Podem ser vendidos separadamente ou como complemento ao seu plano.
            </p>
          </div>

          {/* Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {exercicios.map((ex) => (
              <Link
                key={ex.id}
                to={`/exercicio/${ex.id}`}
                className="group bg-white/[0.03] rounded-2xl border border-gold-500/10 hover:border-gold-500/30 p-6 transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_0_30px_rgba(201,168,76,0.08)] cursor-pointer"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300"
                  style={{ backgroundColor: `${ex.color}20` }}
                >
                  <i className={`${ex.icon} text-2xl`} style={{ color: ex.color }}></i>
                </div>

                <h3 className="font-['Playfair_Display'] text-xl font-semibold text-white mb-1">
                  {ex.emoji} {ex.title}
                </h3>
                <p className="font-['Montserrat'] text-xs text-white/40 mb-4 tracking-wide">
                  {ex.subtitle}
                </p>

                <div className="flex items-baseline gap-2 mb-4 pb-4 border-b border-gold-500/10">
                  <span className="font-['Playfair_Display'] text-2xl font-bold text-gold-400">
                    R$ {ex.precoMin}
                  </span>
                  <span className="text-white/30">—</span>
                  <span className="font-['Playfair_Display'] text-xl font-bold text-white/50">
                    R$ {ex.precoMax}
                  </span>
                </div>

                {/* Meditação Link */}
                <a
                  href={ex.meditacaoLink}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-2 mb-4 px-3 py-2 bg-white/[0.03] rounded-lg border border-gold-500/10 hover:border-gold-500/30 transition-all cursor-pointer"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-youtube-fill text-lg text-red-500"></i>
                  </div>
                  <span className="font-['Montserrat'] text-xs text-white/50 hover:text-gold-400 transition-colors truncate">
                    {ex.meditacaoTitulo}
                  </span>
                  <i className="ri-external-link-line text-xs text-white/30 ml-auto flex-shrink-0"></i>
                </a>

                <div className="w-full py-3 rounded-lg border border-gold-500/30 text-gold-400 font-['Montserrat'] font-semibold text-sm hover:bg-gold-500/10 transition-all whitespace-nowrap cursor-pointer tracking-wider uppercase text-center">
                  Ver Detalhes
                </div>
              </Link>
            ))}
          </div>

          {/* Combo Box */}
          <div className="mt-12 bg-gradient-to-r from-gold-500/10 to-gold-700/10 rounded-2xl p-8 border border-gold-500/20 text-center">
            <div className="flex items-center justify-center gap-3 mb-3">
              <i className="ri-gift-2-line text-3xl text-gold-400"></i>
              <h3 className="font-['Playfair_Display'] text-2xl font-bold text-white">Combine e Economize</h3>
            </div>
            <p className="font-['Montserrat'] text-sm text-white/50 mb-2 font-light">
              Adquira 3 ou mais exercícios avulsos e ganhe <strong className="text-gold-400">15% de desconto</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedExercise && selectedData && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedExercise(null)}
        >
          <div
            className="bg-luxury-dark rounded-3xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-gold-500/20 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="p-8 border-b border-gold-500/10 relative">
              <button
                onClick={() => setSelectedExercise(null)}
                className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-white"></i>
              </button>

              <div className="flex items-start gap-4">
                <div
                  className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: `${selectedData.color}20` }}
                >
                  <i className={`${selectedData.icon} text-3xl`} style={{ color: selectedData.color }}></i>
                </div>
                <div>
                  <h3 className="font-['Playfair_Display'] text-2xl font-bold text-white mb-1">
                    {selectedData.emoji} {selectedData.title}
                  </h3>
                  <p className="font-['Montserrat'] text-sm text-white/50">{selectedData.subtitle}</p>
                </div>
              </div>
            </div>

            <div className="p-8">
              <p className="font-['Montserrat'] text-sm text-white/60 mb-6 leading-relaxed">
                {selectedData.description}
              </p>

              {/* Meta */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-white/[0.03] rounded-xl p-4 border border-gold-500/10">
                  <p className="font-['Montserrat'] text-xs text-white/40 mb-1">Duração</p>
                  <p className="font-['Montserrat'] text-sm text-white font-semibold">{selectedData.duration}</p>
                </div>
                <div className="bg-white/[0.03] rounded-xl p-4 border border-gold-500/10">
                  <p className="font-['Montserrat'] text-xs text-white/40 mb-1">Nível</p>
                  <p className="font-['Montserrat'] text-sm text-white font-semibold">{selectedData.level}</p>
                </div>
              </div>

              {/* Benefits */}
              <div className="mb-6">
                <h4 className="font-['Montserrat'] text-sm font-semibold text-gold-400 mb-4 uppercase tracking-wider">
                  O que está incluído
                </h4>
                <ul className="space-y-3">
                  {selectedData.benefits.map((b, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <div className="w-5 h-5 rounded-full bg-gold-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className="ri-check-line text-xs text-gold-400"></i>
                      </div>
                      <span className="font-['Montserrat'] text-sm text-white/60">{b}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Meditação Recomendada */}
              <div className="mb-6 p-4 bg-white/[0.03] rounded-xl border border-gold-500/10">
                <p className="font-['Montserrat'] text-xs text-gold-400 mb-2 uppercase tracking-wider font-semibold">
                  <i className="ri-headphone-line mr-1"></i> Meditação Recomendada
                </p>
                <a
                  href={selectedData.meditacaoLink}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="flex items-center gap-3 hover:text-gold-400 transition-colors cursor-pointer"
                >
                  <div className="w-10 h-10 rounded-lg bg-red-500/20 flex items-center justify-center flex-shrink-0">
                    <i className="ri-youtube-fill text-xl text-red-500"></i>
                  </div>
                  <div className="flex-1">
                    <p className="font-['Montserrat'] text-sm text-white/70">{selectedData.meditacaoTitulo}</p>
                    <p className="font-['Montserrat'] text-xs text-white/30">Abrir no YouTube</p>
                  </div>
                  <i className="ri-external-link-line text-white/30"></i>
                </a>
              </div>

              {/* Price & CTA */}
              <div className="bg-gradient-to-r from-gold-500/10 to-gold-700/10 rounded-xl p-6 border border-gold-500/20">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <p className="font-['Montserrat'] text-xs text-white/40 mb-1">Investimento</p>
                    <p className="font-['Playfair_Display'] text-3xl font-bold text-gold-400">
                      R$ {selectedData.precoMin} — R$ {selectedData.precoMax}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="font-['Montserrat'] text-xs text-white/40 mb-1">Acesso</p>
                    <p className="font-['Montserrat'] text-sm font-semibold text-white">Vitalício</p>
                  </div>
                </div>
                <Link
                  to={`/exercicio/${selectedData.id}`}
                  className="block w-full py-4 bg-gradient-to-r from-gold-500 to-gold-700 text-white rounded-lg font-['Montserrat'] font-bold hover:shadow-[0_0_30px_rgba(201,168,76,0.3)] transition-all whitespace-nowrap cursor-pointer tracking-wider uppercase text-center"
                >
                  Ver Página Completa
                </Link>
                <p className="text-center font-['Montserrat'] text-xs text-white/30 mt-3">
                  <i className="ri-shield-check-line mr-1"></i> Garantia de 7 dias
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
